import { defineStore } from 'pinia'
import { useI18n } from 'vue-i18n'

export const useLocaleStore = defineStore('locale', {
  state: () => ({
    currentLocale: 'en'
  }),
  actions: {
    setLocale(newLocale) {
      const nextLocale = 'en'
      this.currentLocale = nextLocale
      localStorage.setItem('currentLocale', nextLocale)
      const { locale } = useI18n()
      locale.value = nextLocale
    }
  }
})
